<template>
  <div class="d-flex fd-column ai-center w-100">
    <div class="TITLE">Congratulations {{ firstName }}!</div>
    <div class="m-x-1">
      You've earned credit towards rewards, for answering all the questions correctly.
    </div>
    <img
        :height="$device.isMobile ? 208 : 320"
        class="IMAGE"
        src="./../assets/ForkLift.svg"/>
    <a

        @click="goHome"
        class="btn BUTTON m-b-6">
      Go to Pro Education Home
    </a>
    <div v-if="showWatchNext" class="d-flex fd-column w-100 jc-left">
      <div class="h4 text-bold m-b-1 text-left">Watch next</div>
      <div class=" m-l-3:t CARD-CONTAINER">
        <div v-for="(id, index) in groupList" :key="index" class="CARD">
          <video-card :id="id" @click="watchNext(id)" @video-clicked="watchNext" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import VideoCard from '../../Education/components/VideoCard';

export default {
  name: 'quiz-success',
  components: {
    VideoCard,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters('account/pro/education', ['getExtractedItemsByGroup', 'videoRecords']),
    ...mapGetters('user', ['firstName']),
    showWatchNext () {
      return this.groupList.length > 0;
    },
    groupList () {
      return this.getExtractedItemsByGroup[this.group].filter((item => !this.isWatched(item)));
    },
  },
  methods: {
    ...mapMutations('account/pro/education', ['setVideo']),
    isWatched (id) {
      return this.videoRecords.find(record => String(record.education_quiz_id) === String(id));
    },
    goHome () {
      this.setVideo({});
      this.$events.$emit(this.$events.RETURN_EDUCATION_HOME);
      this.$router.push({ name: 'dashboard::pro::education' });
    },
    watchNext (id, section) {
      this.$events.$emit(this.$events.WATCH_NEXT_VIDEO, { group: section, videoId: id });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .TITLE {
    @include margin(7 0 3 0);
    @include h4();
    font-weight: 600;

    @include mobile-only {
      @include margin(2 0 3 0);
    }
  }
  .CARD-CONTAINER {
    display: flex;
    align-self: center;
    justify-content: start;
    width: 100%;
    flex-wrap: wrap;
    gap: 0 24px;

    @include mobile-only {
      flex-direction: column;
    }
  }
  .CARD {
    width: 264px;
    margin-right:2 * $unit;
    padding-bottom: 2 * $unit;
    @include mobile-only {
      width: 100%;
    }
    cursor: pointer;
  }
  .BUTTON {
    width: fit-content;
  }
  .IMAGE {
    margin-bottom: $unit*7;
  }

</style>
